export const isMigrationRouteWithQueryParams = (url: string) => {
  const migrationRoute = '/migracao';
  const migrationRouteWithQueryParams = `${migrationRoute}?email=`;

  return url.includes(migrationRouteWithQueryParams);
};
